// @mui
import { GlobalStyles as MUIGlobalStyles } from '@mui/material';

// ----------------------------------------------------------------------

export default function GlobalStyles() {
  const inputGlobalStyles = (
    <MUIGlobalStyles
      styles={{
        '*': {
          boxSizing: 'border-box',
        },
        html: {
          margin: 0,
          padding: 0,
          width: '100%',
          height: '100%',
          WebkitOverflowScrolling: 'touch',
        },
        body: {
          margin: 0,
          padding: 0,
          width: '100%',
          height: '100%',
          backgroundColor: '#fff',
        },
        '#root': {
          width: '100%',
          height: '100%',
        },
        '.MuiModal-backdrop': {
          opacity: '0.5 !important',
        },
        '.MuiTablePagination-menuItem': {
          color: '#000',
        },
        '.ant-picker:hover, .ant-picker-focused': {
          borderColor: '#d9d9d9',
        },
        '.ant-picker .ant-picker-input .ant-picker-suffix': {
        },
        '.anticon .anticon-close-circle': {
          marginLeft:"50px",
        },
        '.ant-picker-range .ant-picker-clear': {
          insetInlineEnd: "50px",
        },
        '.ant-picker .ant-picker-input .ant-picker-clear': {
          // display: 'none',
          paddingRight: 40,
        },
        '.MuiInputLabel-shrink': {
          color: '#00000099 !important',
          fontFamily: 'Whitney Semibold',
        },
        input: {
          '&[type=number]': {
            MozAppearance: 'textfield',
            '&::-webkit-outer-spin-button': {
              margin: 0,
              WebkitAppearance: 'none',
            },
            '&::-webkit-inner-spin-button': {
              margin: 0,
              WebkitAppearance: 'none',
            },
          },
        },
        img: {
          display: 'block',
          maxWidth: '100%',
        },
        ul: {
          margin: 0,
          padding: 0,
        },
      }}
    />
  );

  return inputGlobalStyles;
}
